<template>
  <div id="projetsetup">
    <div class="right">
      <div class="right_header">绘图仪型号参数文件</div>
      <div v-if="uploadFile" class="right_button">
        <el-upload ref="upload" :disabled="upload" :show-file-list="false" :http-request="httpRequest" accept=".pmp"
          class="upload-file" action="/">
          <el-button type="primary" size="small" @click="upLoadFile">
            上传
          </el-button>
        </el-upload>
        <span>只能上传pmp格式文件</span>
      </div>
      <div class="right_table">
        <el-table v-loading="loading" :data="tableData" border element-loading-text="拼命加载中" highlight-current-row height="100%">
          <template slot="empty">
            <img :src="zanwu" alt="" />
            <p style="font-size:16px;color:#000;margin-top:36px">暂无数据</p>
          </template>
          <el-table-column label="文件名称" prop="fileName">
            <template slot-scope="{ row }">
              <div style="display:flex;align-items: center">
                <img :src="icon" style="margin-right:8px" alt="" />
                <span>{{ row.fileName }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="修改时间" prop="createTime" min-width="120px" />
          <el-table-column label="文件大小" prop="fileSizeStr" />
          <el-table-column label="操作" width="120" align="center">
            <template slot-scope="scope">
              <el-button type="text" size="mini" @click="deleteRow(scope.row)">
                删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
import print from "@/CommonDP/service/plotterConfig-service.js";
import { checkPermission, disablePrompt } from "@/CommonDP/utils/routeAuth";
import { mapState } from "vuex";
export default {
  name: "ParameterFile",
  data() {
    return {
      loading: false,
      tableData: [],
      icon: require("@/CommonDP/assets/standard/img.png"),
      zanwu: require("@/CommonDP/assets/暂无数据.png"),
      uploadFile: checkPermission(this.$allPerms.PARAMETERFILE_UPLOAD),
      upload: false
    };
  },
  computed: {
    ...mapState({
      enterpriseId: (state) => state.enterprise.enterpriseId
    })
  },
  watch: {},
  created() {
    this.getList();
  },
  methods: {
    async getList() {
      this.loading = true;
      const res = await print.queryPlotterModelParameterList(this.enterpriseId);
      if (res.result === "0") {
        this.tableData = res.data;
        this.loading = false;
      }
    },
    // 上传
    upLoadFile() {
      const a = disablePrompt();
      if (!a) {
        this.upload = true;
      }
    },
    async httpRequest({ file }) {
      const data = new FormData();
      data.append("file", file);
      data.append("enterpriseId", this.enterpriseId);
      const res = await print.uploadPlotterModelParameter(data);
      if (res.result === "0") this.$message.success("上传成功");
      this.getList();
    },
    deleteRow(val) {
      const a = disablePrompt();
      if (a) {
        this.$confirm("是否确定删除？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            print.deletePlotterModelParameter(val.id).then((res) => {
              if (res.result === "0") {
                this.$message({
                  duration: 1000,
                  message: "删除成功",
                  type: "success",
                  showClose: true
                });
                this.getList();
              }
            });
          })
          .catch(() => {});
      }
    }
  }
};
</script>

<style lang="scss" scoped>
$left-width: 226px;
$header-height: 46px;
#projetsetup {
  width: 100%;
  height: 100%;
  position: relative;
  background: #fff;
  .right {
    height: 100%;
    position: relative;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    .right_header {
      border-bottom: 1px solid #ebefff;
      font-size: 16px;
      font-weight: 600;
      color: var(--key-color);
      padding: var(--middle-space) var(--big-space);
    }
    .right_button {
      padding: var(--middle-space) var(--big-space);
      display: flex;
      align-items: center;
      span {
        font-size: 14px;
        margin-left: 20px;
      }
    }
    .right_table {
      height: 1px;
      flex-grow: 1;
      padding: 0 var(--big-space) var(--middle-space);
    }
  }
}
</style>
